"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeProviders = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const composeProviders = (...providers) => function Providers({
  children
}) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: providers.reduceRight((accumulated, Provider) => /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
      children: accumulated
    }), children)
  });
};
exports.composeProviders = composeProviders;
